import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
  Divider,
  Dialog,
  DialogContent,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { getSecureItem } from "../../utilsFunctions";
import { ImageBaseUrl } from "../../Environment";
import PaymentSubscriptionCredits from "../CreditPayment";

const BuySmsCreditsModal = ({ open, onClose, onSubmit }) => {
  const country = getSecureItem("country");
  const [openDialog, setOpenDialog] = useState(false);
  const loggedinUser = getSecureItem("loggedinUser");
  const [selectedPlan, setSelectedPlan] = useState(true);
  const [smsCount, setSmsCount] = useState(1);
  const smsPrice = country?.code == "91" ? 200 : 4;
  const taxRate = country?.code == "91" ? 0.18 : 0.0;

  const subTotal = selectedPlan ? smsPrice * smsCount : 0;
  const tax = selectedPlan ? subTotal * taxRate : 0;
  const total = subTotal + tax;

  const GeneratePayLinkForSub = async () => {
    const PaymentLinkBaseURL = `${ImageBaseUrl}api/razorPay`;

    try {
      const { data } = await axios.post(
        `${PaymentLinkBaseURL}/createPaymentLink`,
        {
          amount: Number(total + "00"),
          currency: country?.code == "91" ? "INR" : "USD",
          accept_partial: false,
          description: `SMS Credits for company - ${loggedinUser?.firstName + " " + loggedinUser?.lastName}`,
          customer: {
            name: loggedinUser?.firstName + " " + loggedinUser?.lastName,
            contact: loggedinUser?.userPhone,
            email: loggedinUser?.userEmail,
          },
          notify: {
            sms: true,
            email: true,
          },
          notes: {
            companyId: loggedinUser?.companyId,
            smsCredits: smsCount * 1000,
            credits: 0,
          },
          showReturnUrl: true,
        },
      );

      if (data?.status) {
        onSubmit(data?.data?.short_url);
      }
    } catch (error) {
      console.error("Error generating payment link:", error);
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontFamily={"Lato"} variant="h6">
              Buy SMS Credits
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedPlan}
                onChange={() => setSelectedPlan(!selectedPlan)}
              />
            }
            label="SMS Credits"
          />

          {selectedPlan && (
            <Box
              border={"1px solid #ddd"}
              borderRadius={3}
              padding={2}
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <IconButton
                  size="small"
                  style={{ backgroundColor: "#eee" }}
                  onClick={() => setSmsCount(Math.max(1, smsCount - 1))}
                >
                  <RemoveIcon />
                </IconButton>
                <Typography fontFamily={"Lato"}>{smsCount}</Typography>
                <IconButton
                  size="small"
                  style={{ backgroundColor: "#eee" }}
                  onClick={() => setSmsCount(smsCount + 1)}
                >
                  <AddIcon />
                </IconButton>
              </Box>
              <Box display="flex" flexDirection={"column"} gap={0}>
                <Typography fontFamily={"Lato"}>
                  {country?.code == "91" ? "₹" : "$"}{" "}
                  {Number(smsPrice.toFixed(2)) * smsCount}
                </Typography>
                <Typography fontFamily={"Lato"}>
                  {smsCount > 1 ? `(1000 x ${smsCount})` : `1000`} Credits
                </Typography>
              </Box>
            </Box>
          )}

          <Box mt={2} border={"1px solid #ddd"} borderRadius={3} padding={2}>
            <Typography fontFamily={"Lato"} variant="h6">
              Bill Details
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Typography fontFamily={"Lato"}>Sub Total</Typography>
              <Typography fontFamily={"Lato"}>
                {country?.code == "91" ? "₹" : "$"} {subTotal.toFixed(2)}
              </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Typography fontFamily={"Lato"}>Taxes & Charges</Typography>
              <Typography fontFamily={"Lato"}>
                {country?.code == "91" ? "₹" : "$"} {tax.toFixed(2)}
              </Typography>
            </Box>
            <Divider style={{ marginBlock: 5 }} />
            <Box
              display="flex"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Typography fontFamily={"Lato"} variant="h6">
                To Pay
              </Typography>
              <Typography fontFamily={"Lato"} variant="h6">
                {country?.code == "91" ? "₹" : "$"} {total.toFixed(2)}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              bgcolor: "#4d66f0",
              borderRadius: 3,
              mt: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
            }}
          >
            <Box display="flex" flexDirection="column">
              <Typography
                fontFamily={"Lato"}
                sx={{ color: "white", fontSize: "14px" }}
              >
                Total Value
              </Typography>
              <Typography
                fontFamily={"Lato"}
                sx={{ color: "white", fontSize: "20px", fontWeight: "bold" }}
              >
                {country?.code == "91" ? "₹" : "$"} {total.toFixed(2)}
              </Typography>
            </Box>

            <Button
              variant="outlined"
              sx={{
                bgcolor: "white",
                color: "#4d66f0",
                fontWeight: "bold",
                borderRadius: "8px",
                "&:hover": { bgcolor: "#e6e6e6" },
              }}
              size="medium"
              disabled={!selectedPlan}
              onClick={GeneratePayLinkForSub}
            >
              PAY NOW
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogContent>
          <PaymentSubscriptionCredits
            credits={smsCount * 1000}
            amount={total}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BuySmsCreditsModal;
